
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Admin from '@/pages/Admin';
import Admin2 from '@/pages/Admin2';
import RoleManager from '@/pages/RoleManager';
import ShortcutsPage from '@/pages/ShortcutsPage';
import ShortcutsManager from '@/pages/ShortcutsManager';

const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Admin />} />
      <Route path="/enhanced" element={<Admin2 />} />
      <Route path="/roles" element={<RoleManager />} />
      <Route path="/shortcuts" element={<ShortcutsPage />} />
      <Route path="/shortcuts-manager" element={<ShortcutsManager />} />
    </Routes>
  );
};

export default AdminRoutes;
